// React Imports
import { ReactElement, useState } from "react";

// Third Party Libraries Imports
import { ColumnsType } from "antd/es/table";
import { Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";

// Local Imports
import CustomSearch from "../../components/custom-search/custom-search";
import CustomTable from "../../components/custom-table/custom-table";
import CustomModal from "../../components/custom-modal/custom-modal";
import DeleteModal from "../../components/delete-modal/delete-modal";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";

const SliderScreen: React.FC = (): ReactElement => {
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.length - b.title.length,
      fixed: "left",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      fixed: "left",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => a.createdAt.length - b.createdAt.length,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: (a, b) => a.updatedAt.length - b.updatedAt.length,
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-3">
          <ReactSVG
            src={"/images/edit.svg"}
            onClick={() =>
              navigate(`/slider-screens/add-slider-screen/${record?.id}`)
            }
          />
          <ReactSVG
            className="delete-icon"
            src={"/images/delete.svg"}
            onClick={() => setOpenDeleteModal(true)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between flex-wrap mb-3">
        <BreadcrumbComponent />
        <Link
          to={"/slider-screens/add-slider-screen"}
          className="flex items-center justify-center bg-blue-500 rounded-[20px] py-[10px] px-[25px] text-white border-0 cursor-pointer mb-5 decoration-transparent"
        >
          <img
            className=" me-2"
            src={"/images/white-add-square.svg"}
            alt="add-fund kamco"
          />
          <span>Add splash screen</span>
        </Link>
      </div>
      <div className="flex items-center justify-between rounded-lg bg-white py-[10px] px-5">
        <p className=" text-black-300 text-base font-bold">3 Splash screens</p>
        <div className="images flex items-center">
          <CustomSearch />
          <Tooltip placement="topLeft" title="Columns settings">
            <img src={"/images/grid.svg"} alt="grid" />
          </Tooltip>
        </div>
      </div>
      <CustomTable columns={columns} data={[]} showPagination={false} />

      <CustomModal
        isVisible={openDeleteModal}
        centered
        width={450}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        className="delete-modal"
      >
        <DeleteModal
          onCancel={() => setOpenDeleteModal(false)}
          text="Delete splash screen!"
          subText="Are you sure you want to delete this splash screen?"
        />
      </CustomModal>
    </div>
  );
};

export default SliderScreen;
